import React, { useState } from "react";
import IconDesc from "../my-course/IconDesc";
import { bookIcon, geoMarkIcon, checkCircleIcon, awardIcon } from "../../../constants/icons";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";

function CourseEventsHeader({isCertificateAvailable, itemBannerImage, itemTitle, itemDescription, className}) {
  return (
    <div className={`${className || ""} course-inner-header course-event-inner-header`} style={{backgroundImage: `url(${itemBannerImage})`,backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}}>
      <Container>
        <Row className="align-items-center">
          <Col lg={8}>
            <div className="course-description">
              <h1>{itemTitle}</h1>
              <p className="mb-1">{itemDescription}</p>
              {
                isCertificateAvailable === '1' &&
                <div className="d-flex align-items-center gap-1 my-3">
                  <IconDesc
                    icon={awardIcon}
                    paraDesc="Certified"
                  />
                </div>
              }
                
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CourseEventsHeader;
